import axios from 'axios'

export const getCountries = async () => axios.get('api/subscription/countries')
export const getUsaStates = async () => axios.get('api/subscription/usa_states')
export const postValidateUser = async (payload) => axios.post('api/subscription/validate_user', payload)
export const postValidateCompany = async (payload) => axios.post('api/subscription/validate_company', payload)
export const postConfirm = async (payload, prefix='') => axios.post(`api${prefix}/subscription/confirmation`, payload)